import React, { useEffect, useState } from "react";

const Preloader = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timeout);
    }, []);

    if (!loading) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
            <div className="w-12 h-12 border-4 border-green-600 border-t-transparent rounded-full animate-spin"></div>
        </div>
    );
};

export default Preloader;
